type DifficultyType = {
  maxEnemies: number;
  enemyTimer: number;
  spawnProbability: number;
};
type Difficulty = 'easy' | 'normal' | 'hard';

export const difficulties: { [key in Difficulty]: DifficultyType } = {
  easy: {
    maxEnemies: 5,
    enemyTimer: 3,
    spawnProbability: 7,
  },
  normal: {
    maxEnemies: 8,
    enemyTimer: 2,
    spawnProbability: 5,
  },
  hard: {
    maxEnemies: 10,
    enemyTimer: 1,
    spawnProbability: 3,
  },
};

export function getDifficulty(points: number): DifficultyType {
  if (points > 1200) {
    return difficulties.hard;
  } else if (points > 600) {
    return difficulties.normal;
  }

  return difficulties.easy;
}
